<div class="carousel-level">
  <h3
    class="carousel-level__title text-center w-full leading-[7rem] -mt-28"
    [innerHTML]="'education-levels.title' | translate"
  ></h3>

  <app-carousel [items]="levels">
    <ng-template let-slide>
      <div class="carousel-level__container">
        <h1 class="carousel-level__name" [innerHTML]="slide.name"></h1>
        <p class="carousel-level__text">
          {{ slide.text }}
        </p>
        <div>
          <img class="carousel-level__img" loading="lazy" [src]="slide.thumbnail" [alt]="slide.name" />
        </div>
      </div>
    </ng-template>
  </app-carousel>
</div>
